export default {
  none: 'none',
  error: 'error',
  success: 'success',
};
